/**
 * Notification Preferences Hooks - Issue #319
 * 
 * React Query hooks for managing user notification preferences
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { 
  notificationsApi,
  type NotificationPreferences,
  type UpdateNotificationPreferencesRequest,
  type NotificationPreferencesResponse
} from '../lib/api/notifications';

// Re-export types for convenience
export type { NotificationPreferences, UpdateNotificationPreferencesRequest, NotificationPreferencesResponse };

// Get user's notification preferences
export function useNotificationPreferences() {
  return useQuery({
    queryKey: ['notification-preferences'],
    queryFn: () => notificationsApi.getPreferences(),
  });
}

// Update notification preferences
export function useUpdateNotificationPreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateNotificationPreferencesRequest) => 
      notificationsApi.updatePreferences(data),
    onSuccess: () => {
      // Invalidate preferences query to refetch
      queryClient.invalidateQueries({ queryKey: ['notification-preferences'] });
    },
  });
}